import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ServiceorderComponent } from './serviceorder.component';

const serviceOrderRoutes: Routes = [
  {
    path: '',
    component: ServiceorderComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(serviceOrderRoutes)],
  exports: [RouterModule],
})
export class ServicerderRoutingModule {}
